import { FormattedMessage, useIntl } from "react-intl";
import ReactHtmlParser from 'react-html-parser';

import CustomIcon from "../../components/custom-icon";

import {
  alpha,
  Box,
  Button,
  darken,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  ImageList,
  Tooltip,
  useTheme
} from "@mui/material";

import ClearIcon from '@mui/icons-material/Clear';
import AttachFile from '@mui/icons-material/AttachFile';
import FileCopyIcon from '@mui/icons-material/FileCopy';

export default function KnowledgeBaseAttachmentsDialog({
  open,
  onClose,
  knowledgeBaseItem,
  clientportal,
  classes,
  classes2,
  getCalledFile,
  copyFileLink,
  loading
}) {
  const intl = useIntl();
  const theme = useTheme();

  const primaryColor = theme.palette.primary.main;
  const defaultClientColor = clientportal?.defaultcolor ? clientportal.defaultcolor : primaryColor;

  const customColor = getCustomColorPrimary(0.09);
  const customColorWithoutImportant = getCustomColorPrimary(0.09, true);

  function getCustomColorPrimary(darkenValue = 0, customIcon = false) {
    const customColor = darken(defaultClientColor, darkenValue);

    if (customIcon) return customColor;

    return `${customColor} !important`;
  }

  function getCommonButtonStyleWithHover(options = {}) {
    const {
      mainBackgroundColor = getCustomColorPrimary(0.1),
      hoverBackgroundColor = getCustomColorPrimary(0.2),
      mainCss = {},
      hoverCss = {}
    } = options;

    return {
      backgroundColor: mainBackgroundColor,
      ...mainCss,
      ":hover": {
        backgroundColor: hoverBackgroundColor,
        ...hoverCss
      }
    }
  }

  function labelDialogContent() {
    if (loading) {
      return (
        <DialogContent className="knowledgebase-dialog-client-details" >
          <FormattedMessage id="Carregando..." />
        </DialogContent>
      )
    }

    return (
      <DialogContent className="knowledgebase-dialog-client-details" >
        <Grid container spacing={0} style={{ marginTop: 15 }}>
          <Grid item xs={12} style={{ marginBottom: 15 }}>
            <h5><FormattedMessage id="description" />:</h5>

            <div style={{ padding: '5px 10px', border: '1px solid rgba(0, 0, 0, 0.5)', borderRadius: 10 }} >
              {ReactHtmlParser(knowledgeBaseItem.description)}
            </div>
          </Grid>

          {(knowledgeBaseItem.knowledgebaseknowledgebasekeywords && knowledgeBaseItem.knowledgebaseknowledgebasekeywords.length > 0) &&
            <Grid item xs={12} style={{ marginBottom: 15 }}>
              <h5><FormattedMessage id="keywords" />:</h5>

              <div className='kb-keys' style={{ justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                {knowledgeBaseItem.knowledgebaseknowledgebasekeywords.map((item, key) => {
                  return (
                    <div
                      className='kb-key'
                      key={key}
                      style={{ marginTop: 15, color: customColorWithoutImportant, borderColor: customColorWithoutImportant }}>
                      {item.knowledgebasekeyword.word}
                    </div>
                  )
                })}
              </div>
            </Grid>
          }

          {knowledgeBaseItem && knowledgeBaseItem.knowledgebaseattachments.length > 0 && (
            <Grid item xs={12}>
              <div className={classes.attachmentsBox}>
                <label>{<FormattedMessage id="attachments" />}</label>

                <ImageList cellHeight={100} className={classes2.ImageList} cols={1}>
                  <ul>
                    {knowledgeBaseItem.knowledgebaseattachments.map(file => {
                      return (
                        <li key={file.attachment.id} style={{ display: "flex", alignItems: "center", gap: 0.2 }}>
                          <CustomIcon icon={AttachFile} color={getCustomColorPrimary(0.5, true)} resetDefaultContainerStyles />

                          <Button
                            sx={{
                              color: `${customColor}`,
                              "&:hover": {
                                backgroundColor: `${alpha(customColorWithoutImportant, 0.1)} !important`,
                              }
                            }}
                            onClick={() => getCalledFile(file.attachment)}
                          >
                            {file.attachment.description}
                          </Button>

                          <Tooltip title={<h5>Copiar link de download</h5>}>
                            <IconButton
                              aria-label="textevidence"
                              onClick={() => copyFileLink(file.attachment)}
                              sx={{
                                ...getCommonButtonStyleWithHover({
                                  mainBackgroundColor: 'transparent',
                                  hoverBackgroundColor: 'transparent',
                                  hoverCss: { filter: 'brightness(0.7)' }
                                })
                              }}
                            >
                              <CustomIcon icon={FileCopyIcon} color={getCustomColorPrimary(0.5, true)} resetDefaultContainerStyles />
                            </IconButton>
                          </Tooltip>
                        </li>
                      )
                    })}
                  </ul>
                </ImageList>
              </div>
            </Grid>
          )}
        </Grid>
      </DialogContent>
    )
  }

  return (
    <Dialog
      maxWidth="md"
      open={open}
      onClose={onClose}
      scroll={'body'}
      aria-labelledby="knowledgebase-dialog-title">
      <DialogTitle id="knowledgebase-dialog-title">
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', color: getCustomColorPrimary(0.3) }}>
          <span># {knowledgeBaseItem.id} | {knowledgeBaseItem.title}</span>

          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              float: 'right',
              ...getCommonButtonStyleWithHover({
                mainBackgroundColor: 'transparent',
                hoverBackgroundColor: 'transparent',
                hoverCss: { filter: 'brightness(0.5)' }
              })
            }}
          >
            <CustomIcon icon={ClearIcon} color={getCustomColorPrimary(0.1, true)} />
          </IconButton>
        </Box>
      </DialogTitle>

      {labelDialogContent()}

      <DialogActions>
        <Grid container spacing={4} justify="flex-end" style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: 15 }}>
          <Grid item xs={12} sm={4}>
            <Button
              variant='contained'
              type="button"
              onClick={onClose}
              sx={getCommonButtonStyleWithHover()}
              fullWidth
            >
              {intl.formatMessage({ id: "close" })}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  )
}